import { Box, Grid } from '@mui/material'
import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { Panel } from '../../layouts'
import OrderList from './OrderList'

const Admin = ({children}) => {

    return (
        <Panel width={300} >
            <Routes >
                <Route path='/' element={<h1>Dashboard</h1>} />
                <Route path='/orders' element={<OrderList />} />
            </Routes>
        </Panel>
    )
}

export default Admin